// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vetting-calendar-view{
    display: block;
    position: relative;
}
.vetting-calendar-view > div{
    display: grid;
    grid-template-columns: repeat(7, 1fr);
}
.vetting-calendar-view-day-item{
    margin: 3px;
    width: 40px;
    height: 40px;
    /* background: rgb(245, 245, 245); */
    display: flex;
}
.vetting-calendar-view-day-item > * {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.vetting-calendar-dot-current-date {
    position: absolute;
    display: inline-block;
    width: 11px;
    height: 4px;
    border-radius: 7px;
    background-color: #909090;
    bottom: 3px;
    left: 14px;
}

.vetting-calendar-view-day-item > .enable {
    background: rgba(144, 220, 255, 0.4);
    color: green;
    cursor: pointer;
    border-radius: 50%;
}

.vetting-calendar-view-item-notactivemonth{
    opacity: 0.4;
}

.vetting-calendar-view-item-activemonth:hover > .enable, .vetting-calendar-view-day-item > .selected{
    background: rgb(0, 162, 255) !important;
    color: #fff;
}

.week-day-names > div {
    text-align: center;
    text-transform: uppercase;
    font-size: 0.8rem;
}
.grid-column-0 {
    grid-column: 7;
}
.grid-column-1 {
    grid-column: 1;
}
.grid-column-2 {
    grid-column: 2;
}
.grid-column-3 {
    grid-column: 3;
}
.grid-column-4 {
    grid-column: 4;
}
.grid-column-5 {
    grid-column: 5;
}
.grid-column-6 {
    grid-column: 6;
}
.vetting-calendar-view-nav{
    display: flex !important;
    align-items: center;
    padding: 10px;
}
.vetting-calendar-view-nav > b{
    flex: 1;
}
.vetting-calendar-view-nav > span {
    cursor: pointer;
}

.vetting-calendar-view-nav > span.disable-btn {
    opacity: 0.5;
}

.vetting-calendar-view-nav span+span{
    margin-left: 20px;
}
.vetting-calendar-wrapper{
    padding: 30px;
    background-color: #fff;
    border-radius: 15px;
}
.vetting-calendar{
    min-width: 392px;
    background: #fff;
    display: flex;
    overflow: hidden;
}
.vetting-calendar-container {
    display: flex;
    width: 0;
    opacity: 0;
    height: 0;
    -webkit-transition: all 200ms ease-in-out;
    -moz-transition: all 200ms ease-in-out;
    -ms-transition: all 200ms ease-in-out;
    -o-transition: all 200ms ease-in-out;
    transition: all 200ms ease-in-out;
    overflow: hidden;
    flex-wrap: wrap;
    justify-content: center;
    background: #e2e2e2;
    margin: -1px;
}

.vetting-calendar-container.active-calendar-container{
    width: 100% !important;
    height: auto !important;
    opacity: 1 !important;
}

.vetting-calendar-details-section {
    padding: 30px 10px 30px 1px;
    min-width: 350px;
    /* max-width: 800px; */
    flex: 1;
    background: #fff;
    padding-left: 7px;
}
.vetting-calendar-booking-section {
    padding: 30px 0;
    /* border-left: 1px solid rgb(224, 224, 224); */
    max-width: 350px;
}

.vetting-calendar-right-section{
    display: flex;
    flex-wrap: wrap;
    background: #fff;
    margin: 0 0 0 1px;
}

.vetting-calendar-booking-time-section {
    padding: 30px 0;
}


.vetting-calendar-container > *+* {
    flex: 1;
    padding-left: 10px;
}

.vetting-calendar-details-section h2{
    font-size: 16px;
    color: gray;
}

.vetting-calendar-details-section h1{
    font-size: 32px;
    font-weight: 600;
    line-height: 32px;
}

.vetting-calendar-details-section h3{
    font-size: 14px;
    color: gray;
}

.vetting-calendar-booking-section h1{
    font-size: 20px;
    color: rgb(44, 44, 44);
}

.vetting-calendar-booking-time-section{
    overflow: hidden;
    /* width: 0; */
    flex: 1;
    -webkit-transition: all 200ms ease-in-out;
    -moz-transition: all 200ms ease-in-out;
    -ms-transition: all 200ms ease-in-out;
    -o-transition: all 200ms ease-in-out;
    transition: all 200ms ease-in-out;
    opacity: 0;
}
.vetting-calendar-booking-time-section.open{
    /* width: 150px !important; */
    min-width: 150px;
    max-width: 350px;
    opacity: 1;
}

.times-list{
    display: flex;
    flex-direction: column;
}
.btn-time{
    margin: 3px;
    border-radius: 3px;
    background: #fff;
    display: flex;
    height: 40px;
    cursor: pointer;
}
.btn-time > * {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
}
.btn-time-label{
    flex:1;
    border: 1px solid rgb(0, 162, 255);
}
.btn-time-confirm {
     width: 0;
     opacity: 0;
     margin-left: 0;
     font-size: 12px;
     background-color: rgb(17, 17, 17);
     color: #fff;
    -webkit-transition: all 200ms ease-in-out;
    -moz-transition: all 200ms ease-in-out;
    -ms-transition: all 200ms ease-in-out;
    -o-transition: all 200ms ease-in-out;
    transition: all 200ms ease-in-out;
}

.btn-time:hover .btn-time-label, .btn-time.active-time .btn-time-label{
    background: rgb(0, 162, 255) !important;
    border: 1px solid rgb(0, 162, 255);
    color: #fff;
}

.btn-time.active-time .btn-time-confirm{
    width: 70px;
    opacity: 1;
    margin-left: 5px;
}

.vetting-calendar-timezone{
    display: flex;
    align-items: center;
    margin-top: 10px;
}
.vetting-calendar-timezone > span{
    margin-right: 10px;
    white-space: nowrap;
}

.vetting-calendar-all-booked {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 42px;
    display: flex !important;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.68);
    z-index: 100;
    text-align: center;
}

.vetting-calendar-all-booked span {
    width: 70%;
    padding: 20px;
    background-color: #f5f5f5;
    border: 1px solid #dedede;
    border-radius: 5px;
    box-shadow: 1px 1px 9px #e6e6e6;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/VettingCalendar/VettingCalendar.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,qCAAqC;AACzC;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;AACjB;AACA;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,OAAO;AACX;AACA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,QAAQ;IACR,UAAU;IACV,SAAS;IACT,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,oCAAoC;IACpC,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,sBAAsB;IACtB,OAAO;IACP,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,+CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,OAAO;IACP,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,oCAAoC;IACpC,iCAAiC;IACjC,UAAU;AACd;AACA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,MAAM;IACN,kCAAkC;AACtC;AACA;KACK,QAAQ;KACR,UAAU;KACV,cAAc;KACd,eAAe;KACf,iCAAiC;KACjC,WAAW;IACZ,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;IACI,uCAAuC;IACvC,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;IACvB,2CAA2C;IAC3C,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;AACnC","sourcesContent":[".vetting-calendar-view{\n    display: block;\n    position: relative;\n}\n.vetting-calendar-view > div{\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n}\n.vetting-calendar-view-day-item{\n    margin: 3px;\n    width: 40px;\n    height: 40px;\n    /* background: rgb(245, 245, 245); */\n    display: flex;\n}\n.vetting-calendar-view-day-item > * {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.vetting-calendar-dot-current-date {\n    position: absolute;\n    display: inline-block;\n    width: 11px;\n    height: 4px;\n    border-radius: 7px;\n    background-color: #909090;\n    bottom: 3px;\n    left: 14px;\n}\n\n.vetting-calendar-view-day-item > .enable {\n    background: rgba(144, 220, 255, 0.4);\n    color: green;\n    cursor: pointer;\n    border-radius: 50%;\n}\n\n.vetting-calendar-view-item-notactivemonth{\n    opacity: 0.4;\n}\n\n.vetting-calendar-view-item-activemonth:hover > .enable, .vetting-calendar-view-day-item > .selected{\n    background: rgb(0, 162, 255) !important;\n    color: #fff;\n}\n\n.week-day-names > div {\n    text-align: center;\n    text-transform: uppercase;\n    font-size: 0.8rem;\n}\n.grid-column-0 {\n    grid-column: 7;\n}\n.grid-column-1 {\n    grid-column: 1;\n}\n.grid-column-2 {\n    grid-column: 2;\n}\n.grid-column-3 {\n    grid-column: 3;\n}\n.grid-column-4 {\n    grid-column: 4;\n}\n.grid-column-5 {\n    grid-column: 5;\n}\n.grid-column-6 {\n    grid-column: 6;\n}\n.vetting-calendar-view-nav{\n    display: flex !important;\n    align-items: center;\n    padding: 10px;\n}\n.vetting-calendar-view-nav > b{\n    flex: 1;\n}\n.vetting-calendar-view-nav > span {\n    cursor: pointer;\n}\n\n.vetting-calendar-view-nav > span.disable-btn {\n    opacity: 0.5;\n}\n\n.vetting-calendar-view-nav span+span{\n    margin-left: 20px;\n}\n.vetting-calendar-wrapper{\n    padding: 30px;\n    background-color: #fff;\n    border-radius: 15px;\n}\n.vetting-calendar{\n    min-width: 392px;\n    background: #fff;\n    display: flex;\n    overflow: hidden;\n}\n.vetting-calendar-container {\n    display: flex;\n    width: 0;\n    opacity: 0;\n    height: 0;\n    -webkit-transition: all 200ms ease-in-out;\n    -moz-transition: all 200ms ease-in-out;\n    -ms-transition: all 200ms ease-in-out;\n    -o-transition: all 200ms ease-in-out;\n    transition: all 200ms ease-in-out;\n    overflow: hidden;\n    flex-wrap: wrap;\n    justify-content: center;\n    background: #e2e2e2;\n    margin: -1px;\n}\n\n.vetting-calendar-container.active-calendar-container{\n    width: 100% !important;\n    height: auto !important;\n    opacity: 1 !important;\n}\n\n.vetting-calendar-details-section {\n    padding: 30px 10px 30px 1px;\n    min-width: 350px;\n    /* max-width: 800px; */\n    flex: 1;\n    background: #fff;\n    padding-left: 7px;\n}\n.vetting-calendar-booking-section {\n    padding: 30px 0;\n    /* border-left: 1px solid rgb(224, 224, 224); */\n    max-width: 350px;\n}\n\n.vetting-calendar-right-section{\n    display: flex;\n    flex-wrap: wrap;\n    background: #fff;\n    margin: 0 0 0 1px;\n}\n\n.vetting-calendar-booking-time-section {\n    padding: 30px 0;\n}\n\n\n.vetting-calendar-container > *+* {\n    flex: 1;\n    padding-left: 10px;\n}\n\n.vetting-calendar-details-section h2{\n    font-size: 16px;\n    color: gray;\n}\n\n.vetting-calendar-details-section h1{\n    font-size: 32px;\n    font-weight: 600;\n    line-height: 32px;\n}\n\n.vetting-calendar-details-section h3{\n    font-size: 14px;\n    color: gray;\n}\n\n.vetting-calendar-booking-section h1{\n    font-size: 20px;\n    color: rgb(44, 44, 44);\n}\n\n.vetting-calendar-booking-time-section{\n    overflow: hidden;\n    /* width: 0; */\n    flex: 1;\n    -webkit-transition: all 200ms ease-in-out;\n    -moz-transition: all 200ms ease-in-out;\n    -ms-transition: all 200ms ease-in-out;\n    -o-transition: all 200ms ease-in-out;\n    transition: all 200ms ease-in-out;\n    opacity: 0;\n}\n.vetting-calendar-booking-time-section.open{\n    /* width: 150px !important; */\n    min-width: 150px;\n    max-width: 350px;\n    opacity: 1;\n}\n\n.times-list{\n    display: flex;\n    flex-direction: column;\n}\n.btn-time{\n    margin: 3px;\n    border-radius: 3px;\n    background: #fff;\n    display: flex;\n    height: 40px;\n    cursor: pointer;\n}\n.btn-time > * {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 3px;\n}\n.btn-time-label{\n    flex:1;\n    border: 1px solid rgb(0, 162, 255);\n}\n.btn-time-confirm {\n     width: 0;\n     opacity: 0;\n     margin-left: 0;\n     font-size: 12px;\n     background-color: rgb(17, 17, 17);\n     color: #fff;\n    -webkit-transition: all 200ms ease-in-out;\n    -moz-transition: all 200ms ease-in-out;\n    -ms-transition: all 200ms ease-in-out;\n    -o-transition: all 200ms ease-in-out;\n    transition: all 200ms ease-in-out;\n}\n\n.btn-time:hover .btn-time-label, .btn-time.active-time .btn-time-label{\n    background: rgb(0, 162, 255) !important;\n    border: 1px solid rgb(0, 162, 255);\n    color: #fff;\n}\n\n.btn-time.active-time .btn-time-confirm{\n    width: 70px;\n    opacity: 1;\n    margin-left: 5px;\n}\n\n.vetting-calendar-timezone{\n    display: flex;\n    align-items: center;\n    margin-top: 10px;\n}\n.vetting-calendar-timezone > span{\n    margin-right: 10px;\n    white-space: nowrap;\n}\n\n.vetting-calendar-all-booked {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 42px;\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(255, 255, 255, 0.68);\n    z-index: 100;\n    text-align: center;\n}\n\n.vetting-calendar-all-booked span {\n    width: 70%;\n    padding: 20px;\n    background-color: #f5f5f5;\n    border: 1px solid #dedede;\n    border-radius: 5px;\n    box-shadow: 1px 1px 9px #e6e6e6;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
